import { motion } from 'framer-motion';
import type { GameState } from '../../types/kotch';

interface MatchResultsProps {
  state: GameState;
  onPlayAgain: () => void;
  onExit: () => void;
}

export default function MatchResults({ state, onPlayAgain, onExit }: MatchResultsProps) {
  const winner = state.winner;
  const winnerName = winner ? state.players[winner].name : 'Draw';
  const isPlayer1Winner = winner === 1;

  const p1 = state.players[1];
  const p2 = state.players[2];

  return (
    <motion.div
      className="kotch-results"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.h2
        initial={{ y: -20 }}
        animate={{ y: 0 }}
        transition={{ delay: 0.2 }}
      >
        Match Complete
      </motion.h2>

      <motion.div
        className="kotch-winner-banner"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.4, type: 'spring' }}
      >
        {winnerName} Wins the Match!
      </motion.div>

      <motion.div
        className="kotch-results-summary"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        <div className="kotch-result-row">
          <span className="kotch-result-label">Final Score</span>
          <span className="kotch-result-value">
            <span className={isPlayer1Winner ? 'win' : 'lose'}>{p1.name}: {state.match.player1BattleWins}</span>
            {' — '}
            <span className={!isPlayer1Winner ? 'win' : 'lose'}>{p2.name}: {state.match.player2BattleWins}</span>
          </span>
        </div>

        <div className="kotch-result-row">
          <span className="kotch-result-label">Battles Played</span>
          <span className="kotch-result-value">{state.match.battlesPlayed}</span>
        </div>

        {state.match.battleHistory.map((battle, index) => (
          <div key={index} className="kotch-result-row">
            <span className="kotch-result-label">Battle {battle.battleNumber}</span>
            <span className={`kotch-result-value ${battle.winnerId === 1 ? 'win' : 'lose'}`}>
              {battle.winnerId === 1 ? p1.name : p2.name}
              {' '}
              ({battle.player1RoundWins}-{battle.player2RoundWins})
            </span>
          </div>
        ))}
      </motion.div>

      <motion.div
        className="kotch-action-buttons"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
      >
        <button className="kotch-button" onClick={onPlayAgain}>
          Play Again
        </button>
        <button className="kotch-button kotch-button-secondary" onClick={onExit}>
          Exit
        </button>
      </motion.div>
    </motion.div>
  );
}
